import './index.less';

import request from '@/utils/request';
import { getLocaleText, setSearchHistory } from '@/utils/utils';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import { lowerFirst } from '@umijs/deps/compiled/lodash';
import { Toast } from 'antd-mobile';
import md5 from 'js-md5';
import { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { getLocale, history } from 'umi';

// import  styles from './index.less';
const Code = (props: any) => {
  const { visable, close, phone, verify, PicData, require } = props;
  const [code, setCode] = useState<any>();
  const [countdownSeconds, setCountdownSeconds] = useState(0);
  const [isActive, setIsActive] = useState(false);

  const intl = useIntl();
  // 关闭弹窗
  const handleClose = () => {
    close();
  };
  // 校验图形验证码并获取验证码
  const checkImgCode = async () => {
    const Url = `${process.env.BMSUrl}bms/user/ctmlogin/getCode`;
    const res = await request.post(Url, {
      data: {
        lang: `${getLocale().replace(/-/gi, '_')}`,
        areaCode: '853',
        platformCode: `${process.env.BMSsiteId}`,
        accountId: phone,
        version: 1,
        picUuid: PicData.picUuid,
        picCode: verify,
      },
    });
    if (res?.code === 200) {
      setCountdownSeconds(180);
      setIsActive(true);
    } else {
      Toast.info(res?.mes);
    }
  };

  // 生成秒数
  useEffect(() => {
    let intervalId: any;
    if (isActive && countdownSeconds > 0) {
      intervalId = setInterval(() => {
        setCountdownSeconds((prevSeconds) => prevSeconds - 1);
      }, 1000);
    } else if (isActive && countdownSeconds === 0) {
      setIsActive(false);
    }

    return () => clearInterval(intervalId);
  }, [isActive, countdownSeconds]);

  // 校验验证码
  useEffect(() => {
    checkImgCode();
  }, []);

  function validateMacaoPhoneNumber(phoneNumber: any) {
    const macaoPhoneRegex = /^[0-9]\d{0,3}$/;
    return macaoPhoneRegex.test(phoneNumber);
  }
  // 登录
  const login = async () => {
    if (!code) {
      Toast.info(
        intl.formatMessage({
          id: 'login.page.pleaseCode',
        }),
      );
    } else {
      const isValidPhoneNumber = validateMacaoPhoneNumber(code);
      if (isValidPhoneNumber) {
        const Url = `${process.env.BMSUrl}bms/user/ctmlogin/login`;
        const res = await request.post(Url, {
          data: {
            lang: `${getLocale().replace(/-/gi, '_')}`,
            picCode: verify,
            userCode: code,
            version: 1,
            platformCode: `${process.env.BMSsiteId}`,
            areaCode: '853',
            accountId: phone,
            spCode: 'CTM',
            mac: '1234567890',
            terminalType: 4,
          },
        });
        if (res?.code === 200) {
          Toast.info(
            intl.formatMessage({
              id: 'login.page.loginSuccess',
            }),
          );
          localStorage.setItem('accountId', res.data.accountId);
          localStorage.setItem('userId', res.data.userId);
          localStorage.setItem('userToken', res.data.userToken);
          localStorage.setItem('netType', res.data.netType);
          res.data.email && localStorage.setItem('ctmEmail', res.data.email);
          res.data.duCode && localStorage.setItem('duCode', res.data.duCode);

          synchronization();
        } else {
          Toast.info(res.mes);
        }
      } else {
        Toast.info(
          intl.formatMessage({
            id: 'login.page.pleaseTrueCode',
          }),
        );
      }
    }
  };
  // 鉴权同步
  const synchronization = async () => {
    const userTypeUrl = `${process.env.BMSUrl}bms/user/ctmlogin/checkCustomerReq?version=1`;
    const userTypeRes = await request.post(userTypeUrl, {
      data: {
        lang: `${getLocale().replace(/-/gi, '_')}`,
        accountId: phone,
        mac: `1234567890`,
        userId: localStorage.getItem('userId'),
        platformCode: `${process.env.BMSsiteId}`,
        userToken: localStorage.getItem('userToken'),
        ctmNumber: localStorage.getItem('duCode')
          ? localStorage.getItem('duCode')
          : phone,
      },
    });
    if (userTypeRes.code == 200) {
      localStorage.setItem('netType', userTypeRes.data.netType);
      const Url = `${process.env.BMSUrl}bms/pay/ctm/checkNewCTMProfileReq?version=1`;
      const res = await request.post(Url, {
        data: {
          accountId: phone,
          lang: `${getLocale().replace(/-/gi, '_')}`,
          userId: localStorage.getItem('userId'),
          platformCode: `${process.env.BMSsiteId}`,
          userToken: localStorage.getItem('userToken'),
          ctmNumber: localStorage.getItem('duCode')
            ? localStorage.getItem('duCode')
            : phone,
        },
      });
    }
    hmovdLogin();
  };

  function extractToken(str: any, regex: any) {
    const match = regex.exec(str); // 使用 exec 方法获取匹配结果
    if (match) {
      return match[1]; // 返回匹配的第一个捕获组
    } else {
      return null; // 如果没有匹配则返回 null
    }
  }
  const hmovdLogin = async () => {
    let params = `mobileno=${phone}&rememberme=on&appVersion=1.0.31&osVersion=25&deviceModel=chrome&deviceSerial=1&network=wifi&language=zh_HK&platform=ctm&areaCode=853`;
    let decode = `${params}&secret=CTM6730454679509094068`;

    let sign = md5(decode);

    let loginURL = `${process.env.HMVODLogin}/ctmLogin.action?${params}&sign=${sign}`;

    let resLogin = await request.get(loginURL);
    const regex = /<token>(.*?)<\/token>/; // 匹配 <token> 和 </token> 之间的任意字符
    let token = await extractToken(JSON.stringify(resLogin), regex);
    localStorage.setItem('token', token);
    if (window.location.href.includes('/login')) {
      history.push({
        pathname: '/home',
      });
    } else {
      history.go(0);
    }
  };
  return (
    <Dialog
      className="code"
      open={visable}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
      disableEnforceFocus
      disableBackdropClick={true}
    >
      <div className="content">
        <DialogContent>
          <DialogContentText>
            {getLocaleText('login.page.verification')}
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            onChange={(v) => setCode(v.target.value)}
            type="email"
            fullWidth
          />
          <div className="seconds">
            <Button
              onClick={require}
              disabled={isActive}
              color="primary"
              className="seconds"
            >
              {isActive
                ? ` ${countdownSeconds} s`
                : `${getLocaleText('login.page.require')}`}
            </Button>
          </div>
        </DialogContent>

        <DialogActions>
          <Button onClick={close} color="primary">
            {getLocaleText('login.page.back')}
          </Button>
          <Button onClick={login} color="primary">
            {getLocaleText('login.page.sureLogin')}
          </Button>
        </DialogActions>
      </div>
    </Dialog>
    // </div>
  );
};

export default Code;
